<template>
  <div>
    <el-upload
      ref="img"
      class="avatar-uploader"
      :show-file-list="false"
      list-type="picture-card"
      action="noaction"
      :multiple="false"
      :http-request="handleUpload"
      :on-remove="handleRemove"
      :before-upload="handleBeforeUpload"
      :on-progress="handleProgress"
      :on-success="handleUploadSuccess"
      :on-preview="handlePreview"
    >
      <!-- <i class="el-icon-plus"></i> -->
      <template v-if="fileList[0].url">
        <slot name="imgPreview">
          <el-image :src="imagsUrl+fileList[0].url" fit="scale-down" />
        </slot>
      </template>
      <i
        v-else-if="!fileList[0].url && videoFlag == false"
        class="el-icon-plus avatar-uploader-icon"
      />
      <el-progress
        v-if="videoFlag"
        type="circle"
        :percentage="uploadPercent"
        class="upload-progress-container"
      />
      <div slot="tip" class="el-upload__tip">
        <el-button v-if="fileList[0].url" type="text" @click="handlePreview"
          >预览</el-button
        >
        {{ uploadTip }}
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="fileList[0].url" alt="" />
    </el-dialog>
  </div>
</template>
<script>
/**
 * 腾讯云cos上传
 */
import { getUUID } from "@/utils";
import { getStsToken } from "@/api/oss";
import COS from "cos-js-sdk-v5";
import cosClient from "./qcloud";
export default {
  name: "SingleUploadCos",
  props: {
    value: String,
    uploadTip: {
      type: String,
      default: "支持jpg/png/jpeg格式"
    }
  },
  data() {
    return {
      videoFlag: false,
      uploadPercent: 0,
      dataObj: {
        host: "",
        bucket: "",
        region: "",
        dir: ""
      },
      imagsUrl:$imgUrl,
      cosClient: null,
      dialogVisible: false
    };
  },
  computed: {
    imageUrl() {
      return this.value;
    },
    imageName() {
      if (this.value != null && this.value !== "") {
        return this.value.substr(this.value.lastIndexOf("/") + 1);
      } else {
        return null;
      }
    },
    fileList() {
      return [
        {
          name: this.imageName,
          url: this.imageUrl
        }
      ];
    },
    showFileList: {
      get: function() {
        return (
          this.value !== null && this.value !== "" && this.value !== undefined
        );
      },
      set: function(newValue) {}
    }
  },
  mounted() {
  },
  methods: {
    getAuthorizationData(res) {
      console.log("res=====", res);
      const { host, bucket, region, dir } = res.data;
      this.dataObj.host = host;
      this.dataObj.dir = dir;
      this.dataObj.bucket = bucket;
      this.dataObj.region = region;
      const { sessionToken, tmpSecretId, tmpSecretKey, expiredTime } = res.data;
      return {
        TmpSecretId: tmpSecretId,
        TmpSecretKey: tmpSecretKey,
        XCosSecurityToken: sessionToken,
        ExpiredTime: expiredTime
      };
    },
    emitInput(val) {
      this.$emit("input", val);
    },
    handleRemove(file, fileList) {
      this.emitInput("");
    },
    handlePreview(file) {
      this.dialogVisible = true;
    },
    handleUpload(req) {
      const { file } = req;
      getStsToken().then(res => {
        const { bucket, region, dir, host } = res.data;
        this.cosClient = new COS({
          getAuthorization: (options, callback) => {
            let data = this.getAuthorizationData(res);
            callback({ ...data });
          }
        });
        this.videoFlag = true;
        this.cosClient.putObject(
          {
            Bucket: bucket,
            Region: region,
            Key: dir + file.name,
            Body: file,
            onProgress: function(progressEvent) {
              this.uploadPercent = Number((progressEvent.loaded / progressEvent.total * 100).toFixed(2))
              console.log("上传中===", JSON.stringify(progressEvent));
            }
          },
          (err, data) => {
            if (err) {
              this.$message({
                type: "error",
                message: err
              });
            }

            this.videoFlag = false;
            this.uploadPercent = 0;
            this.showFileList = true;
            const { host, dir } = this.dataObj;
            this.fileList.pop();
            this.fileList.push({
              name: file.name,
              url: `${dir}${file.name}`
            });
            this.emitInput(this.fileList[0].url);
          }
        );
      });
    },
    handleBeforeUpload(file) {
      console.log(file.type);
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (["image/jpg", "image/jpeg", "image/png"].indexOf(file.type) == -1) {
        this.$message.error("请上传正确的图片格式");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传大小不能超过10MB哦!");
        return false;
      }
    },
    handleProgress( file, fileList) {
      this.videoFlag = true;
      const size = file.size/1024/1024 > 0.1 ? `(${(file.size/1024/1024).toFixed(1)}M)` : `(${(file.size/1024).toFixed(1)}KB)`
      file.name.indexOf('M')>-1 || file.name.indexOf('KB')>-1 ? file.name : file.name += size
      this.uploadPercent = file.percentage.toFixed(0);
    },
    handleUploadSuccess(res, file) {
      console.log("11");
      this.videoFlag = false;
      this.uploadPercent = 0;
      console.log("上传成功...");
      this.showFileList = true;
      this.fileList.pop();
      this.fileList.push({
        name: file.name,
        url: "/" + file.name
      });
      this.emitInput(this.fileList[0].url);
    }
  }
};
</script>
<style>
.avatar-uploader {
  position: relative;
}
.upload-progress-container {
  position: absolute;
  top: 10px;
  left: 10px;
}
</style>
